import React, { useEffect, useState } from "react";
import axios from "axios";
import { useSnackbar } from "notistack";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";

import { config } from "../App";
import { Box } from "@mui/system";
import { Grid } from "@mui/material";
import VideoCard from "./VideoCard";
import VideoPlayerView from "./VideoPlayerView";
import "./VideoPage.css";

const VideoPageView = () => {
  const params = useParams();
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const [video, setVideo] = useState({});
  const [allVideoList, setAllVideoList] = useState([]);

  useEffect(() => {
    getVideoData(params.id);
    getAllVideos();
  }, [params.id]);

  const getAllVideos = async () => {
    let response;
    try {
      response = await axios.get(`${config.endpoint}/videos`);
      setAllVideoList(response.data.videos);
    } catch (e) {
      handleError(e);
    }
  };

  const getVideoData = async (id) => {
    try {
      const response = await axios.get(`${config.endpoint}/videos/${id}`);
      console.log(response.data);
      setVideo(response.data);
    } catch (e) {
      handleError(e);
      navigate("/");
    }
  };

  const handleError = (e) => {
    if (e.response) {
      enqueueSnackbar(e.response.data.message, { variant: "error" });
    } else {
      enqueueSnackbar(
        "Something went wrong. Check that the backend is running, reachable and returns valid JSON.",
        { variant: "error" }
      );
    }
  };

  return (
    <>
      <Box className="header-box" sx={{ height: "10vh", bgcolor: "#202020" }}>
        <Box display="flex" justifyContent="start" alignItems="center">
          <Box className="header-title">
            <Link
              to="/"
              style={{
                display: "flex",
                color: "white",
                textDecoration: "none",
              }}
            >
              <h1>
                <span style={{ color: "red" }}>X</span>Flix
              </h1>
            </Link>
          </Box>
        </Box>
      </Box>

      <Grid container paddingY="1rem" paddingX="2rem" spacing={3}>
        {video ? (
          <Grid item xs={12}>
            <VideoPlayerView video={video} getVideoData={getVideoData} />
          </Grid>
        ) : (
          <div style={{ color: "#fff" }}>Loading...</div>
        )}

        {allVideoList.map((video) => (
          <Grid item xs={12} sm={6} md={3} key={video._id}>
            <Link
              to={`/video/${video._id}`}
              className="video-tile-link"
              style={{ textDecoration: "none", color: "white" }}
            >
              <VideoCard video={video} />
            </Link>
          </Grid>
        ))}
      </Grid>
    </>
  );
};

export default VideoPageView;
